export function logNewRelic(message: string, data: any, level: 'info' | 'warn' | 'error' = 'error') {
  if (typeof window !== 'undefined' && 'newrelic' in window) {
    (window.newrelic as any).log(message, {
      level,
      customAttributes: data,
    })
  }
}

/**
 * Creates a logger function with predefined context that can be reused throughout a component/file
 * @param baseContext - Common context data to be included in all logs (e.g., businessId, userId, etc.)
 * @returns Logger function that accepts message, level, and additional context
 */
export function createLoggerWithContext(baseContext: Record<string, any>) {
  return (message: string, level: 'info' | 'warn' | 'error', additionalContext: Record<string, any> = {}) => {
    logNewRelic(message, { ...baseContext, ...additionalContext }, level)
  }
}

export function setNewRelicUserId(userId: string | number | undefined | null) {
  if (typeof window !== 'undefined' && 'newrelic' in window) {
    try {
      // Set userId to null to clear it on logout, or to the string value when logging in
      (window.newrelic as any).setUserId(userId ? String(userId) : null)
    } catch(error) {
      // Silently fail if setUserId is not available or errors
      console.warn('Failed to set NewRelic user ID:', error)
    }
  }
}
